export default "__VITE_ASSET__e99e1144__"